import { APIcallerv2 } from '../APIcaller';
import { config } from '../../config';
import axios from '../../core/http';

const baseApiUrl = `${config.baseApiUrl}/v1`;

export const triggerRelaunchAnalytics = async ({
  type,
  endDate,
  clientId,
  storeIds,
  startDate,
  userTimezone = 'Europe/Paris',
}) => {
  const { data } = await axios.post(
    `${baseApiUrl}/backoffice/general/analytics/relaunch`,
    {
      type,
      clientId,
      endDate,
      storeIds,
      startDate,
      userTimezone,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    },
  );

  return data;
};

export const getRelaunchAnalyticsStatus = async (clientId, type) => {
  const { data } = await axios.get(
    `${baseApiUrl}/backoffice/general/analytics/relaunch/${clientId}/status`,
    {
      params: { type },
      headers: {
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    },
  );

  return data;
};

const getLastRelaunchLog = async () =>
  APIcallerv2.apiGet(`/backoffice/general/analytics/last-relaunch`);

const getAnalyticsHistory = async () => APIcallerv2.apiGet(`/backoffice/general/analytics/history`);

export default {
  triggerRelaunchAnalytics,
  getRelaunchAnalyticsStatus,
  getLastRelaunchLog,
  getAnalyticsHistory,
};
